import React, { Component } from 'react';

export default class Controller_Cell extends Component {
	constructor(props) {
		super(props);
		this.state = {
		}
	}

	handleOnClick = () => {
		if (this.props.controller_info.is_available) {
			document.getElementById('cell_' + this.props.index).classList.add('fadeIn');
			this.props.handleOnClick(this.props.index);
		}
	}

	render() {
		let cell_style = {
			cursor: 'pointer',
			width: this.props.width - 20,
			border: this.props.controller_info.is_selected && this.props.controller_info.is_available ? '2px solid #0098de' : 'none',
			borderRadius: 10,
			margin: 10,
			padding: 10,
			backgroundColor: this.props.controller_info.is_available ? 'white' : 'grey',
			verticalAlign: 'top',
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
		}

		return (
			<div id={"cell_" + this.props.index} style={cell_style} onClick={this.handleOnClick}>
				<div>
					<div style={{ display: 'inline-block', marginRight: this.props.controller_info.name != '' ? 10 : 0 }}>
						<span style={{ fontSize: 20, fontWeight: 'bold' }}>{this.props.controller_info.name}</span>
					</div>
					<div style={{ display: 'inline-block', marginRight: 10 }}>
						<span>{'DCP' + this.props.controller_info.model} </span>
					</div>
					<div style={{ display: 'inline-block' }}>
						<span>{'v' + this.props.controller_info.version} </span>
					</div>
				</div>
				<div style={{ marginTop: 5 }}>
					<div style={{ display: 'inline-block', marginRight: 10 }}>
						<span>{this.props.controller_info.ip_addr} </span>
					</div>
					<div style={{ display: 'inline-block', marginRight: 10 }}>
						<span>{this.props.controller_info.mac_addr} </span>
					</div>
				</div>
			</div>
		)
	}
}


